import Vue from 'vue'
import App from '@/App.vue'
import vueMeta from 'vue-meta'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import firebase from 'firebase'
import Notifications from 'vue-notification'
import wb from '@/registerServiceWorker'
import {
  dismissAiAccessNotice,
  promptAiAccessAfterLogin,
  resetAiAccessLoginPrompt
} from '@/composables/useAIAccessNotification'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.prototype.$workbox = wb
Vue.use(Notifications)
Vue.use(vueMeta)
Vue.config.productionTip = false

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'fa'
})

let app = null

// Add a loading state to wait for Firebase auth
let firebaseAuthReady = false

// Store the subscription listener unsubscribe function
let subscriptionUnsubscribe = null

firebase.auth().onAuthStateChanged(async user => {
  firebaseAuthReady = true
  let shouldPromptAiAccess = false

  if (user) {
    // Update login state in Vuex
    store.commit('setIsLoggedIn', true)

    try {
      await store.dispatch('getProfile')
    } catch (error) {
      console.error('Failed to load profile after login:', error)
    }

    // Set up subscription listener - it will handle all permission updates
    if (!subscriptionUnsubscribe) {
      try {
        subscriptionUnsubscribe = await store.dispatch(
          'setupSubscriptionListener'
        )
        shouldPromptAiAccess = true
      } catch (error) {
        console.error('Failed to set up subscription listener:', error)
      }
    }
  } else {
    dismissAiAccessNotice()
    resetAiAccessLoginPrompt()
    // Update login state in Vuex
    store.commit('setIsLoggedIn', false)

    // Clear profile state
    store.commit('clearProfile')

    // Reset permissions to defaults
    store.commit('setPermissions', {})

    // User logged out, clean up all listeners
    if (subscriptionUnsubscribe) {
      subscriptionUnsubscribe()
      subscriptionUnsubscribe = null
    }

    // Clean up links and favourites listeners
    store.dispatch('cleanupListeners')
  }

  if (app === null) {
    createApp()
  }

  if (shouldPromptAiAccess) {
    promptAiAccessAfterLogin()
  }
})

function createApp() {
  if (firebaseAuthReady) {
    app = new Vue({
      vuetify,
      store,
      router,
      render: h => h(App)
    }).$mount('#app')
  }
}

// Wait for the Vue app to be created before mounting it
createApp()
